import React, { memo, useMemo, useState } from "react";

import "./AxiomTagSelection.scss";

function AxiomTagSelection(props) {
  const { options, selectedOptions, onSelection, placeholder = "" } = props;

  const [isAutoCompleteOpen, setAutoComplete] = useState(false);
  const [searchText, setSearchText] = useState("");

  const autocompleteOptions = useMemo(() => {
    function isMatching(option) {
      return (
        (option.displayName != null &&
          String(option.displayName).toLowerCase().includes(searchText.toLowerCase())) ||
        (option.key != null && String(option.key).toLowerCase().includes(searchText.toLowerCase()))
      );
    }
    const selectionKeys = selectedOptions.map((o) => o.key);
    let selectionOptions = options.filter((o) => !selectionKeys.some((s) => s === o.key));
    if (searchText) {
      selectionOptions = selectionOptions.filter(isMatching);
    }
    return selectionOptions;
  }, [options, selectedOptions, searchText]);

  const closeAutoComplete = () => {
    setTimeout(() => setAutoComplete(false), 200);
  };

  return (
    <div className="axiom-tag-selection">
      <div className="axiom-tag-selection-box">
        {selectedOptions.map((o) => (
          <div key={o.key} className="axiom-tag-selection-tag">
            {o.displayName}
            <button
              onClick={(e) => onSelection(o)}
              className="axiom-tag-selection-close axiom-tag-action"
            >
              &times;
            </button>
          </div>
        ))}
        <input
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onFocus={() => setAutoComplete(true)}
          placeholder={placeholder}
          className="axiom-tag-selection-input"
          type="text"
        />
      </div>
      <div
        className={`axiom-tag-selection-autocomplete nice-scroll ${
          isAutoCompleteOpen && "is-open"
        }`}
      >
        {autocompleteOptions.map((option) => (
          <button
            key={option.key}
            onClick={() => {
              onSelection(option);
              closeAutoComplete();
            }}
            className="axiom-tag-selection-option axiom-tag-action"
          >
            {option.displayName}
          </button>
        ))}
      </div>
    </div>
  );
}

export default memo(AxiomTagSelection);
